import { z } from 'zod';

const renderedOutreachOutputSchema = z.object({
    render_artifact: z.object({
        component: z.literal('outreach_detail'),
        outreach_id: z.uuid(),
    }),
});

export type V3OutreachPresentation = {
    readonly outreachId: string;
};

/** Parse the explicit v3 render receipt for a live outreach detail card. */
export function parseV3OutreachPresentation({
    toolName,
    output,
}: {
    readonly toolName: string;
    readonly output: unknown;
}): V3OutreachPresentation | null {
    if (toolName !== 'render_dynamic_ui') {
        return null;
    }
    const parsed = renderedOutreachOutputSchema.safeParse(output);
    return parsed.success
        ? { outreachId: parsed.data.render_artifact.outreach_id }
        : null;
}
